/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Media_Imported_SuccessInputs */



/**
* | output |
* | --- |
* | "Media imported successfully" |
*
* @param {Player_Media_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_media_imported_success = /** @type {((inputs?: Player_Media_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Media_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Media importe avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien erfolgreich importiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del contenuto multimediale riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиафайлы успешно импортированы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios importados exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体文件导入成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアが正常にインポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया सफलतापूर्वक आयात हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia importada com sucesso")
	return /** @type {LocalizedString} */ ("Media imported successfully")
});